import { httpService } from 'core-utilities';
import React, { useEffect, useState } from 'react';
import { EnvironmentUrls } from 'Roblox';
import ModerationPage from '../moderation/ModerationPage';
import ScreentimeLimitPageLoader from '../screentimeLimit/ScreentimeLimitPageLoader';
import { NotApprovedData, RestrictionSource, readNotApprovedData } from './utils/types';
import LocaleRestrictionPageLoader from '../localeRestriction/LocaleRestrictionPageLoader';

const NOT_APPROVED_URL = `${EnvironmentUrls.userModerationApi}/v2/not-approved`;

async function fetchNotApproved(): Promise<NotApprovedData> {
  const urlConfig: { url: string; withCredentials: boolean } = {
    url: NOT_APPROVED_URL,
    withCredentials: true
  };
  const res = await httpService.get(urlConfig);
  return readNotApprovedData(res.data);
}

function App(): JSX.Element | null {
  const [notApprovedData, setNotApprovedData] = useState<NotApprovedData>();

  /* Fetch /v2/not-approved on mount. */
  useEffect(() => {
    // eslint-disable-next-line no-void
    void (async () => {
      let fetchedNotApprovedData: NotApprovedData;
      try {
        fetchedNotApprovedData = await fetchNotApproved();
      } catch (e) {
        // TODO More elegant error handling.
        console.error(e);
        return;
      }

      setNotApprovedData(fetchedNotApprovedData);
    })();
  }, []);

  /* Don't render anything until data is fetched. */
  if (!notApprovedData) {
    // TODO(nngai) Would be good to have a loading symbol here and an error state.
    return null;
  }

  /* Null restriction case will just use the moderation page for backwards compatibility. */
  if (!notApprovedData.restriction) {
    return <ModerationPage />;
  }

  switch (notApprovedData.restriction?.source) {
    case RestrictionSource.Moderation:
      return <ModerationPage />;

    case RestrictionSource.Screentime:
      return <ScreentimeLimitPageLoader />;

    case RestrictionSource.LocaleUnavailable:
      return <LocaleRestrictionPageLoader />;

    default:
      throw new Error(`Invalid restriction source: ${notApprovedData.restriction.source}`);
  }
}

export default App;
